// map life and signage common

import './handleLocale.js';
import './translation.js';
import './analytics';
import 'modules/QR';
import './imageControl';
import './optimizedImageUpload';
import '../modules/DateTimePicker';
import '../modules/Input';
import * as AccountUtils from '../../../../common/AccountUtils';
import * as MapUtils from '../../../../common/MapUtils';
import DOMMapUtils from './DOMMapUtils';
import * as NumberUtils from '../../../../common/NumberUtils';
import * as SpotUtils from '../../../../common/spotUtils';

window.AccountUtils = AccountUtils;
window.MapUtils = {
  ...DOMMapUtils,
  ...MapUtils,
};
window.NumberUtils = NumberUtils;
window.SpotUtils = SpotUtils;
